import React, { useRef } from 'react'
import { useProvider } from '../../App'
import { getCategories } from '../../lib/getProvider';
import { useProviderContext } from '../../context/MapProviderContext';

const Categories = () => {
    const filterButtonsRefs = useRef([]);

    const {
        isLoading,
        error,
        providers,
        setFilters,
        config
    } = useProviderContext()

    if (isLoading) return config.content.fetch_states.loading;
    if (error) return config.content.fetch_states.error;

    const handleFilterTrigger = (cssClass) => {
        const { current: filterButton } = filterButtonsRefs;

        setFilters(current => {
            if (current.includes(cssClass)) return current.filter(item => item !== cssClass)
            return [...current, cssClass]
        })

        filterButton[cssClass].children[0].classList.toggle('left-0');
        filterButton[cssClass].children[0].classList.toggle('left-1/2');
        filterButton[cssClass].children[0].classList.toggle('border-brand-primary-500');
        filterButton[cssClass].children[0].classList.toggle('border-slate-500');
        filterButton[cssClass].classList.toggle('bg-brand-primary-500');
        filterButton[cssClass].classList.toggle('bg-slate-500');
    }

    if (getCategories(providers).length <= 1) return null;

    return (
        <div>
            <h3>{config.content.category_heading}</h3>
            {
                getCategories(providers).map(({ cssClass, label }, index) => {
                    if (getCategories(providers).length <= 1) return null;

                    return (
                        <div className='flex-1 basis-[49%] md:basis-[32%] py-2 md:py-4 pr-4 border-bottom border-1-solid-grey border-slate-200 last:border-b-0' key={index}>
                            <span className='flex justify-between'>
                                <span className="font-normal normal-case tracking-normal flex cursor-pointer text-[1rem]">
                                    <div className={`service-icon ${cssClass} w-6 h-6 mr-4`}></div>
                                    {label}
                                </span>
                                <button
                                    onClick={() => handleFilterTrigger(cssClass)}
                                    ref={el => filterButtonsRefs.current[cssClass] = el}
                                    className={`cursor-pointer bg-brand-primary-500 w-12 border-0 p-0 rounded-full flex relative transition-all duration-700`}
                                >
                                    <div
                                        className="
                                            bg-white
                                            w-6
                                            h-full
                                            rounded-full
                                            box-border
                                            border-solid
                                            border-2
                                            border-brand-primary-500
                                            absolute
                                            left-1/2
                                            transition-all
                                            duration-700
                                            ease-[cubic-bezier(0.99, 0.71, 0, 0.99)]
                                        "
                                    ></div>
                                </button>
                            </span>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Categories
